import { render } from "./UpdateRequired.vue?vue&type=template&id=6e9f9de0&scoped=true"
import script from "./UpdateRequired.vue?vue&type=script&lang=js"
export * from "./UpdateRequired.vue?vue&type=script&lang=js"

import "./UpdateRequired.vue?vue&type=style&index=0&id=6e9f9de0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9f9de0"]])

export default __exports__